export default {"src":"/_next/static/media/satisfaction-user-sad-icon.381236ad.svg","height":15,"width":14};